export const UMB_COLLECTION_ALIAS_CONDITION = 'Umb.Condition.CollectionAlias';
export const UMB_COLLECTION_HAS_ITEMS_CONDITION_ALIAS = 'Umb.Condition.CollectionHasItems';
